import {
    createStyles,
    WithStyles,
    withStyles
} from '@mui/styles';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import {
    RenderTree
} from '../../../shared/components/node-tree';
import { Typography } from '@mui/material';
import { EntityFloorplan } from '../../../shared/domain';
import { FolderTree } from '../../folder-tree';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        height: '100%'
    },
    title: {
        marginTop: '1em',
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '0.2em',
        borderBottom: '1px solid'
    }
});

interface Props {
    folderTreeData?: RenderTree;
    onFolderTreeClick?: (folderId: string) => Promise<RenderTree[]>;
    onSelectFloorplan?: (selectedFloorplan: EntityFloorplan | undefined) => void;
    onFolderTreeToggle?: (folderIds: string[]) => void;
    foldersClicked?: string[];
    foldersExpanded?: string[];
    isLoading: boolean;
}

class AddReportWizardStepFolderTree extends React.Component<Props & WithStyles<typeof styles>> {
    public static defaultProps = {};

    public render() {
        const {
            classes,
            isLoading,
            folderTreeData,
            foldersExpanded,
            foldersClicked,
            onFolderTreeClick,
            onFolderTreeToggle,
            onSelectFloorplan
        } = this.props;

        return (
            <div className={classes.root}>
                <Typography
                    className={classes.title}
                    variant="h5"
                >
                    Select Floor
                </Typography>
                <FolderTree
                    folderTreeData={folderTreeData}
                    foldersClicked={foldersClicked}
                    foldersExpanded={foldersExpanded}
                    onFolderTreeClick={onFolderTreeClick}
                    onFolderTreeToggle={onFolderTreeToggle}
                    onSelectFloorplan={onSelectFloorplan}
                    isLoading={isLoading}
                />
            </div>
        );
    }
}

const MUIComponent = withStyles(styles)(AddReportWizardStepFolderTree);
export {MUIComponent as AddReportWizardStepFolderTree};
export type AddReportWizardStepFolderTreeProps = Props;
